// @flow
import React, { PureComponent } from "react";
import PickBetsPicture from "@fdr/static-ui/SvgImages/PickBetsPicture";
import { type NullaryFn } from "@tvg/types/Functional";
import {
  DifficultyLevelContainer,
  DollarSign,
  DollarSigns,
  HelpContainer,
  HelpImageContainer,
  HelpTextContainer,
  Label,
  PotentialPayoutContainer,
  TextParaf,
  VeryHardLabel
} from "./styled-components";
import Button from "../../_atoms/Button";

export type Props = {
  paraf1: string,
  paraf2: string,
  paraf3: string,
  onClose: NullaryFn<*>
};

export default class PickBetsHowItWorksTemplate extends PureComponent<Props> {
  static defaultProps = {
    paraf1: "",
    paraf2: "",
    paraf3: ""
  };

  render() {
    return (
      <HelpContainer>
        <HelpImageContainer>
          <PickBetsPicture />
        </HelpImageContainer>
        <HelpTextContainer>
          <DifficultyLevelContainer>
            <Label>Difficulty Level</Label>
            <VeryHardLabel>Very Hard</VeryHardLabel>
          </DifficultyLevelContainer>
          <PotentialPayoutContainer>
            <Label>Potential Payout</Label>
            <DollarSigns>
              {Array(5)
                .fill("$")
                .map((val) => (
                  <DollarSign>{val}</DollarSign>
                ))}
            </DollarSigns>
          </PotentialPayoutContainer>
          {this.props.paraf1 && <TextParaf>{this.props.paraf1}</TextParaf>}
          {this.props.paraf2 && <TextParaf>{this.props.paraf2}</TextParaf>}
          {this.props.paraf3 && (
            <TextParaf>
              <b>TIP - </b>
              {this.props.paraf3}
            </TextParaf>
          )}
          <Button isStretched onClick={this.props.onClose}>
            Close
          </Button>
        </HelpTextContainer>
      </HelpContainer>
    );
  }
}
